import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import {Observable} from "rxjs";
import {apiUrl} from "../../environments/environment";
import {ProjectCustomStatuses} from "../_models/project";
import {AreaStatusSettings} from "../_models/areaStatusSettings";

@Injectable({
  providedIn: 'root'
})
export class ProjectAreaStatusesService {

  constructor(private http: HttpClient) { }

  getProjectAreaStatuses(projectId: number): Observable<AreaStatusSettings> {
    return this.http.get<AreaStatusSettings>(`${apiUrl}/project/${projectId}/areaStatus`, {withCredentials: true})
  }

  saveProjectAreaStatuses(projectId: number, settings: AreaStatusSettings) {
    return this.http.put(`${apiUrl}/project/${projectId}/areaStatus`, settings, {withCredentials: true})
  }

  deleteStatusWithReplacement(projectId: number, version: number, deleteStatusId: number, replaceWithId: number, timestamp: number): Observable<number> {
    return this.http.delete<number>(`${apiUrl}/project/${projectId}/areaStatus`,  {params: {deleteStatusId, version, replaceWithId, timestamp}, withCredentials: true})
  }
}
